import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
} from 'react-router-dom';
import { APP_ENV } from './consts';
import pkg from '../../package.json';
import { User } from 'firebase/auth';

const SENTRY_ENABLED = import.meta.env.PROD;
console.log(`PRODUCTION: ${SENTRY_ENABLED}, ENV: ${APP_ENV}`);

// Puppet Interview
const DSN = 'https://bb19411d209f431fac8921e6effcb74b@o279785.ingest.sentry.io/1535083';

export function log(message: string, data?: unknown) {
    if (data) {
        breadcrumb(message, 'auto-breadcrumb', data);
    }
    if (SENTRY_ENABLED) {
        Sentry.captureMessage(message);
    } else {
        console.warn(message, data);
    }
}

export function logError(error: Error) {
    if (SENTRY_ENABLED) {
        Sentry.captureException(error);
    } else {
        console.error(error);
    }
}
export function setSentryUser(user: User | null) {
    if (SENTRY_ENABLED) {
        const sentryUser: Sentry.User | null = user
            ? { displayName: user.displayName, email: user.email || '', id: user.uid }
            : null;
        Sentry.setUser(sentryUser);
    }
}

export const initializeSentry = () => {
    Sentry.init({
        dsn: DSN,
        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
            Sentry.replayIntegration(),
        ],
        enabled: SENTRY_ENABLED,
        environment: APP_ENV,
        release: pkg.version,
        tracesSampleRate: 1.0,
        // Set sendDefaultPii to true if you want to collect user IP addresses
        // Set to false (or omit) if you don't want to collect IP addresses
        sendDefaultPii: true,
        // Session replay sample rate
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
};

export function breadcrumb(message: string, category: string, crumb?: unknown) {
    if (SENTRY_ENABLED) {
        // Sentry types breadcrumb data as a string-keyed record, but callers pass arbitrary
        // values (including `unknown` catch bindings), so widen only at the SDK boundary.
        const data = crumb as Sentry.Breadcrumb['data'];
        Sentry.addBreadcrumb({ category: category, message: message, data });
    } else {
        // console.warn(`BREADCRUMB: ${message}:`, crumb);
    }
}
